import * as types from '../../action-types';
import { deleteAdmin as initialState } from '../initialStates';

const deleteAdmin = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.DELETE_ADMIN_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.DELETE_ADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccessful: true,
            }
        case types.DELETE_ADMIN_FAIL:
            return {
                ...state,
                isLoading: false,
                error: payload
            }
        case types.DELETE_ADMIN_CLEANUP:
            return {
                ...state,
                isSuccessful: false,
                error: null,
            }
        default:
            return state;
    };
};

export default deleteAdmin;
